import React from 'react';
// import { nanoid } from '@reduxjs/toolkit';
// components
import MNPGV2 from "@/components/MainPageLayouts/components/MNPGV2";
// hooks
import useMainPageItems from '@/hooks/useMainPageItems';
// types
import { THeaderComponent } from './type';


// const unqKey = nanoid(12);
const Header = ( props:THeaderComponent ) => {
    // const headerTemplates = useMainPageItems({unqKey:unqKey, mapLayoutName:["MNPGGRP_001"]});
    const headerTemplates = useMainPageItems({mapLayoutName:"MNPGGRP_001"});

    if ( !headerTemplates ) return null;

    return (
        <header className="header-section">
            <MNPGV2 templates={headerTemplates} mapLayoutName={"MNPGGRP_001"} />
        </header>
    )
}

const Component = React.memo(Header, ( prevProps:THeaderComponent, nextProps:THeaderComponent ) => {
    console.log("Header.memo", { prevProps, nextProps });
    return true;
});

export default Component;
